export default "__VITE_ASSET__Dr62KLoj__"